import { afterNextRender, ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { LocationService } from '../../location.service';
import { backend } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'gift-claim',
  templateUrl: './gift-claim.component.html',
  styleUrls: ['./gift-claim.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export default class ClaimGiftWelcomeComponent {
  destroy = inject(DestroyRef);
  isLoading = signal<boolean>(true);
  http = inject(HttpClient);
  router = inject(LocationService);
  activated = inject(ActivatedRoute);
  toast = inject(ToastrService);

  constructor() {

    afterNextRender(() => {
      const identifier = this.activated.snapshot.queryParams.id;

      if(identifier){
        this.http.post<{ result: string }>(backend + 'distribution', { identifier }).pipe(takeUntilDestroyed(this.destroy)).subscribe({
          next: result => {
  
            this.isLoading.set(false);
          },
          error: error => {
            //todo: set redirect to /gift/claim?id=${identifier}
            //prompt with button for redirect
            error = error.error || error;
            console.log(error.message);
            this.router.navigate(['/gift'], { queryParams: { identifier }});
            this.toast.error('There was a problem with redeeming your gift. Please try again or contact us if the issue persists');
          }
        });
      }
    });
  }
}
